import styled from "styled-components";

export default styled.div`
  border: 1px solid
    ${({ open, edit, editName }) =>
      open ? (edit ? "#a36257" : "#40677E") : editName ? "#a36257" : "#c4c4c4"};
  padding: 20px;
  border-radius: 5px;
  background-color: ${({ open }) => (open ? "#F1ECE4" : "#FFFFFF")};
  transition: background-color 400ms ease-out;
  margin-bottom: 15px;
  width: inherit;
  max-width: inherit;
  box-sizing: border-box;
  position: relative;
  ${({ edit, editName }) =>
    (edit || editName) && "box-shadow: 0 0 20px rgba(0, 0, 0, 0.03)"};

  @media (max-width: 768px) {
    border-radius: 0;
  }
`;



// WEBPACK FOOTER //
// ./src/nekrasovka-ui/Accordion/AccordionContainer.js